import React, { useState, createContext } from "react";

export const LoginContext = createContext();

function decodeAuth(token) {
  if (!token) return { loggedIn: false, userId: null, role: null };
  try {
    const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64));
    return {
      loggedIn: true,
      userId: payload.userId ?? payload.id ?? null,
      role: payload.role ?? payload.roles ?? null,
    };
  } catch {
    return { loggedIn: true, userId: null, role: null };
  }
}

export const LoginProvider = (props) => {
  // Initialise synchronously from localStorage so loggedIn is never null.
  // Decodes the stored JWT to extract userId and role for client-side
  // permission checks, eliminating the need for *WithPermission queries.
  const [auth, setAuth] = useState(() => decodeAuth(localStorage.getItem("token")));

  return (
    <LoginContext.Provider value={[auth, setAuth]}>
      {props.children}
    </LoginContext.Provider>
  );
};
